<template>
  <div>
    <page-content-header
      :item="item"
    />
    <b-container>
      <b-row>
        <b-col>
          <node-element-local-tasks
            v-if="itemid"
            :itemid="itemid"
          />
          <!-- <div
            v-if="notpublished"
            class="messages warning"
          >Not published</div> -->
        </b-col>
      </b-row>
        <b-row>
        <b-col md="6">
          <page-content-wysiwg-content
            v-if="hasBody"
            :item="item"
            class="page-body"
          />
          </b-col>
          <b-col md="6">
          <form>
            <div class="form-header">
              <h1 class="title">Send us an email</h1>
            </div>
            <div class="input-group">
              <div class="input select">
                <label for="enquiryType">Reason for Enquiry <span
                        v-if="!formData.enquiryType"
                        class="required"
                >*</span></label>
                <select
                        id="enquiryType"
                        v-model="formData.enquiryType"
                        class="form-control"
                >
                  <option
                          v-for="(enquiryType, index) in enquiryTypes"
                          :key="index"
                          :value="enquiryType"
                          :selected="formData.enquiryType === enquiryType"
                  >
                    {{ enquiryType }}
                  </option>
                </select>
              </div>
            </div>
            <!-- Street & City -->
            <div class="input-group">
              <div class="input">
                <label for="name">Full Name<span
                        v-if="!formData.fullname"
                        class="required"
                >*</span></label>
                <input
                        id="name"
                        v-model="formData.fullname"
                        type="text"
                        class="form-control"
                        placeholder="Full Name"
                >
              </div>
            </div>
            <div class="input-group">
              <div class="input">
                <label for="email">Email Address
                  <span
                          v-if="!formData.email"
                          class="required"
                  >*</span>
                </label>
                <input
                        id="email"
                        v-model="formData.email"
                        type="email"
                        class="form-control"
                        placeholder="test@example.org"
                >
              </div>

              <div class="input">
                <label for="phone">Phone</label>
                <input
                        id="phone"
                        v-model="formData.phone"
                        type="text"
                        class="form-control"
                        placeholder="00 0000 0000"
                >
              </div>
            </div>

            <div class="input-group">
              <div class="input">
                <label for="message">Your Message
                  <span
                          v-if="!formData.message"
                          class="required"
                  >*</span>
                </label>
                <textarea
                        id="message"
                        v-model="formData.message"
                        type="text"
                        class="form-control"
                >Your message
                </textarea>
              </div>
            </div>

            <div class="form-actions">

              <b-button
                      :disabled="disabled"
                      type="button"
                      variant="primary"
                      class="webform-submit"
                      @click="submitWebform(formData)"
              >Submit your message</b-button>

            </div>

          </form>
      <div id="recaptcha-container" />

      </b-col>
      </b-row>

    </b-container>
  </div>
</template>
<script>
// reCAPTCHA Client Side Key: 6Ld0uY8UAAAAALwH49lbpEuAYuLqNsWTJVoP7Enr
// reCAPTCHA Server Side Key: 6Ld0uY8UAAAAAChibrRS5nWV-5YPKs6kQOeifDao
import {asyncData, pageMixin, formMixin} from '../generic-webform-common'
import recaptchaMixin from '../recaptcha-mixin'

let title = ''

export default {
  name: 'generic-webform',
  asyncData: (args) => {
    return asyncData(args)
      // .then(item => {
      //   title = item.title
      //   if (typeof window !== 'undefined') {
      //     document.title = item.title
      //   }
      // })
  },
  mixins: [
    pageMixin,
    formMixin,
    // recaptchaMixin
  ],
  props: {
    nid: {
      type: Number,
      required: false,
      default: () => {
        return false
      }
    }
  },
  title: () => {
    return title
  }
}
</script>

<style scoped lang="scss">

    form {
        background: var(--main-input-form-background-color);
        color: var(--main-input-form-text-color);
        padding: 1em 1em 2em 1em;
        margin-bottom:2rem;

      .form-header {
        padding: 1em 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          max-height: 10em;
          flex: 1;
          margin: -5em 0 0 -4em;
        }
        .title {
          flex: 3;
        }
      }

        .form-actions {
            padding: 0 1em;

            .webform-submit {
            width:100%;
            padding:1em 2em;
            }
        }

    .input-group {
        display: flex;
        margin-bottom: 0;

        .input {
            flex: 2;
            position: relative;
            margin: 0 2em 0 0;
            box-sizing: border-box;

            &.password {

                .password-icon {
                    position: absolute;
                    width: 1.5em;
                    height: 1.5em;
                    top: 1.5em;
                    left: .5em;
                }

                .form-control.password {
                    text-indent: 2em;
                }

                .change-password {
                    position: absolute;
                    top: .75em;
                    right: 1em;
                }
            }

            &.select {
                flex: 1;

                select {
                    height: 4.5em;
                }
            }

            label {
                position: absolute;
                top: .25em;
                left: .25em;
                transition: all 0.2s ease-in-out;
                color: var(--main-input-label-color);
                font-weight: bold;
            }
            .form-control {
                padding: 2em 0em .75em .5em;
                font-size: 1.1em;
                border-width: 0;
                transition: all 0.2s ease-in-out;
                outline: 0;
                width: 100%;
                background: #FFF;
                border-bottom: 1px solid var(--main-input-border-color);

                &.disabled {
                    background: rgba(0,0,0,0.05) !important;
                }
            }
        }
    }

    .input-group {

      .input {
        flex: 2;
        position: relative;
        margin: 1em;
        box-sizing: border-box;

        &.select {
          flex: 1;
        }

        &:after {
          position: absolute;
          content: "";
          border-bottom: 2px solid var(--main-input-border-color);
          bottom: 0;
          width: 0;
          height: 2px;
          margin: auto;
          right: 0;
          left: 0;
          transition: all 0.2s ease-in-out;
        }

        &:hover {
          label {
            top: -1.5em;
          }

          &:after {
            border-color: var(--main-input-border-color);
            width: 100%;
          }
        }

        .form-control {
          padding: 2em 0 .75em .5em;
          font-size: 1.1em;
          border-width: 0;
          transition: all 0.2s ease-in-out;
          outline: 0;
          width: 100%;
          border-bottom: 1px solid transparent;
        }

        select {
          &.form-control {
            padding-bottom: .7em;
          }
        }

      }
    }
  }
</style>
